export default __webpack_public_path__ + "static/media/Kiara's Gratitude.bc6f8cf7.jpg";